<template>
    <div class="all">
        <!-- 筛选 -->
        <div class="screen clearfix">
            <div class="fl">
                <div class="corm fr clearfix">
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/presentationCenter'}">简报列表</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/ordinaryTemplate'}">自定义简报模板</router-link>
                    <router-link class="element curr" :to="{path:''+$parent.baseUrl+'/timingTemplate'}">定时报告模板</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/timelyReporting'}">定时报告</router-link>
                    <router-link class="element" :to="{path:''+$parent.baseUrl+'/industryProducts'}">竞品/行业</router-link>
                </div>
            </div>
            <div class="fr">
                <button class="btn btn-jbblue" @click="addTimingTemplate();"><i class="icons add-icon"></i>新增定时模板</button>
            </div>
        </div>
        <!-- 预警信息列表 -->
        <div class="warp mt20">
            <div class="warp-body">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="30%">
                        <col width="15%">
                        <col width="20%">
                        <col width="20%">
                        <col width="20%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>模板名称</th>
                            <th>频率</th>
                            <th>下次发送时间</th>
                            <th>创建时间</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in reportList" :key="index">
                            <!-- <div v-if="item.reportType == 1"></div> -->
                            <td>{{item.templateName}}</td>
                            <td v-if="item.reportType == 1">每天</td>
                            <td v-if="item.reportType == 2">每周</td>
                            <td v-if="item.reportType == 3">每月</td>
                            <td v-if="item.reportType == 4">一次</td>
                            <td>{{item.nextSendTime}}</td>
                            <td>{{item.createdAt}}</td>
                            <td>
                                <div class="table-all-icons">
                                    <i class="icons eye-icon" title="预览" @click="showTimingTemplate(item.templateId,item.type)"></i>
                                    <i class="icons edit-icon" title="修改" @click="editTimingTemplate(item.id)"></i>
                                    <i class="icons del-icon" title="删除简报" @click="delReport(item.id)"></i>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data pt30" v-if="nodata"><img :src="$parent.baseUrl+'/static/images/no_data.png'" class="img"/><span class="text">没有数据哦...</span></div>
                <!-- 分页 -->
                <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
        </div>
        <Dialog ref="delDialog" :callback="delModal">
            <div slot="mdBox" >
                <div class="ac">确定删除报告吗？</div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import page from '../../../components/page.vue';
import Dialog from '../../../components/dialog.vue';

export default {
    data() {
        return {
            caseId:'',
            reportList:[],
            currentPage: 1,//当前页码
            limit: 20,//每页显示条数
            totalCount:0,//总条数
            reportId:0,
            nodata:false
        }
    },
    components:{
        Dialog,page
    },
    mounted() {
		let that = this;
		that.$nextTick(()=> {
            that.dataAjax();
        })
    },
    created() {
		// 获取缓存方案数据
        this.caseId = JSON.parse(sessionStorage.getItem('planStorage')).id;
    },
    methods: {
        // 预览
        showTimingTemplate(id) {
            let routeData = this.$router.push({ path: this.$parent.baseUrl+'/addNewOrdinaryTemplate',query:{id:id,isPreview:true}})
            // window.open(routeData.href, '_blank');
        },
        // 新增定时模板
        addTimingTemplate () {
            this.$router.push({ path:''+this.$parent.baseUrl+'/addTimingTemplate'})
        },
        editTimingTemplate (id) {
            this.$router.push({ path:''+this.$parent.baseUrl+'/addTimingTemplate',query:{id:id}})
        },
        dataAjax(){
            let that = this;
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('report/timing-report/list',{sid:that.caseId,perpage:that.limit,page:that.currentPage},r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    that.reportList = r.data.list;
                    if(r.data.list.length<=0){
                        that.nodata = true;
                        return
                    }else{
                        that.nodata = false;
                    }
                    that.totalCount = Math.floor(r.data.count);
                });
            });
        },
        getTableData() {
           this.dataAjax()
        },
        //删除报告
        delReport(id){
            let that = this;
            that.reportId = id;
            that.$refs.delDialog.showMaskFun();
        },
        delModal(){
            let that = this;
            that.$refs.delDialog.closeMask();
            that.$api.post('report/timing-report/delete',{id:that.reportId},r=>{
                that.$parent.returnCode(r,function(){
                    that.$utils.alertText('删除成功！',200);
                    that.$store.dispatch('show/changeToast',{text:'删除成功！'})
                    that.currentPage = 1;
                    that.dataAjax()
                });
            });
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/presentation/timingTemplate.vue